import React, { useEffect, useState, useMemo } from "react";
import api from "api";
import { formatDate, debug } from "utils";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { FiPlus } from "react-icons/fi";
import "./css/admin-formalities.css";
export default function AdminFormalitiesRequestsList({
  requests = [],
  loading = false,
  statuses = {},
}) {
  const navigate = useNavigate();
  const openRequest = (req) => {
    navigate(`/admin/formalities/request/${req.frId}`);
  };
  if (loading) {
    return <p>Chargement...</p>;
  }
  if (!requests.length) {
    return <p className="text-muted">Aucune demande trouvée.</p>;
  }
  return (
    <div className="row">
      {requests.map((req) => {
        const title =
          req.frCustomName ||
          req.template?.ftName ||
          "Formalité";

        const clientName =
          `${req.user?.userFirstname || ""} ${req.user?.userName || ""}`.trim() ||
          "Client inconnu";

        const createdAt = formatDate(
          req.frCreatedAt,
          "d/m/Y H:i"
        );

        return (
          <div key={req.frId} className="col-12 mb-3">
            <div
              className="admin-request-card"
              onClick={() => openRequest(req)}
            >
              <div className="admin-request-card-header d-flex justify-content-between">
                <h5 className="admin-request-card-title text-truncate">
                  {title}
                </h5>
                <span
                  className="admin-request-card-status"
                  style={{
                    backgroundColor:
                      statuses[req.frStatus]?.color || "#888",
                    color: "white",
                  }}
                >
                  {statuses[req.frStatus]?.label || req.frStatus}
                </span>

              </div>

              <div className="admin-request-card-body">
                <div className="admin-request-card-line">
                  Client : {clientName}
                </div>
                <div className="admin-request-card-line">
                  Créée le : {createdAt}
                </div>
                {req.template?.category && (
                  <div className="admin-request-card-line text-muted">
                    Catégorie : {req.template.category.fcName}
                  </div>
                )}
              </div>

              <div className="admin-request-card-footer py-2 d-flex justify-content-between">
                <div></div>
                <button className="btn btn-sm btn-outline-primary rounded-pill">
                  <FiPlus size={16} />
                </button>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
